var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCampaignIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none",
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.026 3h2.488c.181-.011 3.35-.235 6.369-2.766A1 1 0 0 1 13.526 1v10a1 1 0 0 1-1.643.766c-2.36-1.98-4.813-2.548-5.857-2.706v1.982a1 1 0 0 1-.445.833l-.687.458a1 1 0 0 1-1.524-.583l-.736-2.772a3 3 0 0 1 .392-5.978m1.313 8.492v.007l.687-.458V9h-1.35zM3.026 8h2V4h-2a2 2 0 1 0 0 4"
})));
export { SvgCampaignIconActive as ReactComponent };
export default __webpack_public_path__ + "46f883915252a138c2cc9eee0aa09069.svg";